import { Component, Input, HostListener, ElementRef, Renderer2, ViewChild } from '@angular/core';

@Component({
  selector: 'ngx-thumb-image',
  templateUrl: './thumb-image.component.html',
  styleUrls: ['./thumb-image.component.css']
})
export class ThumbImageComponent {
  
  @Input() imageUrl: string = '';
  @ViewChild('fullImage') fullImage: ElementRef<HTMLDivElement>;

  isFullImage: boolean = false;

  @HostListener('document:mouseup', ['$event'])
  clickout(e) {
    const subdiv = this.fullImage.nativeElement.firstChild as HTMLDivElement;
    if (subdiv) {
        this.closeImage();
    }
  }


  protected closeImage() {
    this.isFullImage = false;
  }

  protected showFullImage() {
    this.isFullImage = true;
  }

}